import React from 'react';
import {toTitleCase} from "services/string";
import ProgressBar, {ProgressBarColour} from "components/ProgressBar";
import {DataImport, DataImportStatus} from "../../types/DataImport";

// Types ----

type ImportProgressBarProps = {
  dataImport: DataImport
}

// Helpers ----

const statusColours: Record<DataImportStatus, ProgressBarColour> = {
  "pending": "yellow",
  "ongoing": "brand",
  "failed": "red",
  "complete": "green",
}

// Component ----

function DataImportProgressBar({dataImport}: ImportProgressBarProps) {

  const title = dataImport.status === 'complete' ?
    `Imported from ${toTitleCase(dataImport.source)}` :
    `Importing from ${toTitleCase(dataImport.source)}...`;

  return (
    <ProgressBar
      title={title}
      progress={dataImport.progress}
      colour={statusColours[dataImport.status]}
      label={dataImport.status !== "ongoing" && toTitleCase(dataImport.status)}
      live={dataImport.status === "ongoing"}
    />
  );
}

// Export ----

export default DataImportProgressBar;